import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { format } from 'date-fns';

export const exportarExcel = async ({
  empresa = '',
  nombreReporte = 'Reporte',
  fecha = new Date(),
  columnas = [],       // [{ label, value }]
  datos = [],          // [{ ... }]
  nombreArchivo = 'reporte'
}= {}) => {

   if (!datos.length || !columnas.length) return;

  const fechaFormateada = format(new Date(fecha), 'dd/MM/yyyy');

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet('Reporte');

   /* ===============================
     Encabezado
  =============================== */

  const totalColumnas = 6;//columnas.length;

  // Empresa
  worksheet.mergeCells(1, 1, 1, totalColumnas);
  worksheet.getCell('A1').value = empresa;
  worksheet.getCell('A1').font = { bold: true, size: 16 };
  worksheet.getCell('A1').alignment = { horizontal: 'center', vertical: 'middle' };

  // Nombre del reporte
  worksheet.mergeCells(2, 1, 2, totalColumnas);
  worksheet.getCell('A2').value = `Reporte: ${nombreReporte}`;
  worksheet.getCell('A2').font = { bold: true, size: 13 };
  worksheet.getCell('A2').alignment = { horizontal: 'center' };

  // Fecha
  worksheet.mergeCells(3, 1, 3, totalColumnas);
  worksheet.getCell('A3').value = `Fecha: ${fechaFormateada}`;
  worksheet.getCell('A3').font = { size: 11 };
  worksheet.getCell('A3').alignment = { horizontal: 'center' };

  // Fila separadora
  worksheet.addRow([]);
  /* ===============================
     Fila de encabezados REAL
  =============================== */
  const headerRow = worksheet.addRow(columnas.map(c => c.label));
  headerRow.font = { bold: true };
  headerRow.alignment = { horizontal: 'center' };

  const headerRowNumber = headerRow.number;

  /* ===============================
     Datos
  =============================== */
// datos.forEach(item => {
//     worksheet.addRow(
//       columnas.map(col => item[col.label] ?? '')
//     );

    
//   });
// ===============================
// Datos con estilo
// ===============================
datos.forEach((item, rowIndex) => {
  const row = worksheet.addRow(
    columnas.map(col => item[col.label] ?? '')
  );

  // Color de filas alternas
  if (rowIndex % 2 === 0) {
    row.eachCell(cell => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFF2F2F2' } // gris claro
      };
    });
  }

  // Formatear números y fechas
  row.eachCell((cell, colNumber) => {
    const col = columnas[colNumber - 1]; // -1 porque ExcelJS empieza en 1
    const value = item[col.label];

    if (value === null || value === undefined) return;

    switch(col.format){
      case 'integer':
      cell.numFmt = '#,##0'; // 👉 1, 2, 3 (SIN decimales)
      break;

      case 'decimal':
      cell.numFmt = '#,##0.00'; // 👉 1.25
      break;

      case 'text':
      cell.numFmt = '@'; // texto puro
      break;

      case 'date':
      cell.numFmt = 'dd/mm/yyyy';
      break;

    }

    
  });
});

  

  /* ===============================
     Auto filtro
  =============================== */

    worksheet.autoFilter = {
    from: { row: headerRowNumber, column: 1 },
    to: { row: headerRowNumber, column: columnas.length }
  };
  

worksheet.columns.forEach((column, colIndex) => {
  let maxLength = 0;

  // Considera encabezados
  const headerCell = worksheet.getRow(headerRowNumber).getCell(colIndex + 1);
  if (headerCell.value) maxLength = headerCell.value.toString().length;

  // Considera todas las celdas debajo del encabezado
  for (let i = headerRowNumber + 1; i <= worksheet.rowCount; i++) {
    const cell = worksheet.getRow(i).getCell(colIndex + 1);
    if (cell.value) {
      maxLength = Math.max(maxLength, cell.value.toString().length);
    }
  }

  // Agregar un pequeño margen
  column.width = maxLength + 2;
});

  headerRow.eachCell(cell => {
  cell.fill = {
    type: 'pattern',
    pattern: 'solid',
    fgColor: { argb: 'FFD9D9D9' }
  };
});

  /* ===============================
     Descargar
  =============================== */

  const buffer = await workbook.xlsx.writeBuffer();
  saveAs(
    new Blob([buffer]),
    `${nombreArchivo}_${fechaFormateada.replaceAll('/', '-')}.xlsx`
  );

};
